import { useEffect, useState } from "react";
import Subscription from "./subscription";
import { getAvailableSubscriptions } from "./subscription-service";
import Skeleton from "react-loading-skeleton";
import MonthlyYearComponent from "../../shared-components/MonthlyYearComponent";

const SubscriptionPackages = ({ isUpsellModal , place = "" }: { isUpsellModal: boolean; place?: string }) => {
  const [subscriptions, setSubscriptions] = useState<Package[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isMonthlyView, setIsMonthlyView] = useState<boolean>(true);

  //test
  const handleChildData = (data: boolean) => {
    setIsMonthlyView(data);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await getAvailableSubscriptions();
        const data = (await response.json()) as Package[];
        const sortedData = createSortedData(data);
        setSubscriptions(sortedData);
      } catch (error) {
        console.error(`Error while retrieving subscriptions - ${JSON.stringify(error)}`);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const createSortedData = (data: Package[]) => {
    if (isMonthlyView) {
      data.sort(
        (a, b) =>
          a.prices.find(price => price.interval === "month").unit_amount -
          b.prices.find(price => price.interval === "month").unit_amount
      );
    } else {
      data.sort(
        (a, b) =>
          a.prices.find(price => price.interval === "year").unit_amount -
          b.prices.find(price => price.interval === "year").unit_amount
      );
    }
    return data;
  };

  const getPriceDetails = (prices: Price[]) => {
    if (isMonthlyView) {
      return prices.find(price => price.interval === "month");
    }
    return prices.find(price => price.interval === "year");
  };

  // Get the average of all the discounted yearly price
  const getYearlyDiscount = () => {
    const yearlyDiscount: number[] = [];
    subscriptions.forEach(subscription => {
      const yearlyPrice = subscription.prices.find(price => price.interval === "year");
      if (yearlyPrice.metadata["discount_yearly_tab"] !== undefined) {
        yearlyDiscount.push(Number(yearlyPrice.metadata["discount_yearly_tab"]));
      }
    });

    return Math.max(...yearlyDiscount);
  };

  useEffect(() => {
    if (
      !isLoading &&
      (window.location.hash === "#Premium" ||
        window.location.hash === "#Ultimate" ||
        window.location.hash === "#Essential" ||
        window.location.hash === "#FreePostal")
    ) {
      let el: any = null;
      if (window.location.hash === "#Essential") {
        el = document.getElementById("Essential");
      } else if (window.location.hash === "#Premium") {
        el = document.getElementById("Premium");
      } else if (window.location.hash === "#Ultimate") {
        el = document.getElementById("Ultimate");
      } else if (window.location.hash === "#FreePostal") {
        el = document.getElementById("FreePostal");
      }
      if (!el) return;

      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isLoading]);

  return (
    <div className="w-full flex flex-col items-center gap-6 lg:gap-8 px-4" id={"botb-cards"}>
      <MonthlyYearComponent getYearlyDiscount={getYearlyDiscount()} handleChildData={handleChildData} />

      {isLoading ? (
        <Skeleton
          count={3}
          inline
          highlightColor="#fff"
          containerClassName="w-full mb-[35px] grid grid-cols-1 gap-5 lg:gap-6 lg:grid-cols-3 lg:items-start lg:mb-16 lg:max-w-[1032px] lg:mx-auto"
          className="flex flex-col !rounded-3xl w-full h-[435px] lg:h-[497px]"
        />
      ) : (
        <div className="grid grid-cols-1 gap-5 lg:gap-6 lg:grid-cols-3 lg:items-start lg:max-w-[1032px] lg:mx-auto">
          {subscriptions.map(subscription => (
            <Subscription
              isUpsellModal={isUpsellModal}
              place={place}
              key={subscription.productId}
              productId={subscription.productId}
              metaData={subscription.metadata}
              subscriptionName={subscription.name}
              features={subscription.features}
              priceDetails={getPriceDetails(subscription.prices)}
              description={subscription.description} // need for mobile devices
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SubscriptionPackages;
